import pick from 'lodash/pick';

export default function transformForPatch(creative) {
  // Only send editable fields
  return pick(creative, [
    'name',
    'origin',
    'genders',
    'mediaSet',
    'imageType',
    'countryCodes',
    'categories',
    'productIds',
    'productTags',
  ]);
}
